@if (isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in"
    (click)="onClose()"
  >
    <div
      class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="p-6 border-b border-gray-100 flex justify-between items-center bg-amber-50">
        <h3 class="text-xl font-bold text-gray-800 flex items-center gap-2">
          <lucide-icon [img]="icons.Bell" class="w-5 h-5 text-amber-500"></lucide-icon>
          Join the Wishlist
        </h3>
        <button (click)="onClose()" class="text-gray-400 hover:text-gray-600 cursor-pointer">
          <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6">
        <p class="text-gray-600 mb-4">
          Tell us why you need <span class="font-semibold">{{ featureName$ | async }}</span>. 
          Your feedback helps us prioritize and you'll get early access when it's ready!
        </p>
        
        <div class="space-y-4">
          <div>
            <label for="reason" class="block text-sm font-medium text-gray-700 mb-2">
              Why do you need this feature?
            </label>
            <textarea
              id="reason"
              [(ngModel)]="reason"
              rows="4"
              class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent resize-none text-gray-700 placeholder-gray-400"
              placeholder="e.g., I need to create homework assignments for my students and track their progress..."
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="p-6 pt-0 flex gap-3 justify-end">
        <button
          (click)="onClose()"
          class="px-4 py-2 text-gray-600 font-medium bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer"
        >
          Cancel
        </button>
        <button
          (click)="onSubmit()"
          class="px-4 py-2 text-white font-bold rounded-lg transition-colors cursor-pointer bg-amber-500 hover:bg-amber-600 flex items-center gap-2"
        >
          <lucide-icon [img]="icons.Send" class="w-4 h-4"></lucide-icon>
          Submit
        </button>
      </div>
    </div>
  </div>
}
